import React from 'react';
import { Button, Dropdown, Menu, Table } from 'semantic-ui-react';

import { Contexto } from 'src/contexto';
import { puedePoseerMatriculas } from 'src/modulos/Matriculas/puedePoseerMatriculas';
import { Filtro, ResumenMatricula } from '../../comun/tipos';
import { CabeceraAsesor, FilaAsesor } from './FilaAsesor';
import { CabeceraSupervisor, FilaSupervisor } from './FilaSupervisor';

interface Props {
    listaDeMatriculas: Array<ResumenMatricula>;
    filtroActual: Filtro;
    cargando: boolean;
    rango: React.ReactNode;

    alPresionarRecargar(): void;
    alCambiarFiltro(tipo: Filtro): void;
}

const TablaDeProcesos: React.FC<Props> = props => {
    const {
        alCambiarFiltro,
        filtroActual,
        cargando,
        rango,
        alPresionarRecargar,
        listaDeMatriculas,
    } = props;

    return (
        <Contexto.Consumer>
            {({ usuarioActual }) => {
                const esAsesor = puedePoseerMatriculas(usuarioActual);
                const Fila = esAsesor ? FilaAsesor : FilaSupervisor;
                const Cabecera = esAsesor ? CabeceraAsesor : CabeceraSupervisor;

                return (
                    <div>
                        {' '}
                        <Menu
                            borderless
                            size='large'
                            attached='top'
                            style={{ backgroundColor: '#f0f0ff' }}
                        >
                            <Menu.Item fitted='vertically'>
                                <Button
                                    style={{ height: '40px', width: '40px' }}
                                    basic
                                    icon='refresh'
                                    loading={cargando}
                                    onClick={alPresionarRecargar}
                                />
                            </Menu.Item>

                            <Dropdown
                                fitted='vertically'
                                text={mapaDeNombresDeFiltros[filtroActual]}
                                item
                            >
                                <Dropdown.Menu>{itemsDesdeFiltros(alCambiarFiltro)}</Dropdown.Menu>
                            </Dropdown>

                            <Menu.Item fitted='vertically' position='right'>
                                {rango}
                            </Menu.Item>
                        </Menu>
                        <Table attached='bottom' selectable>
                            <Table.Header>
                                <Cabecera />
                            </Table.Header>

                            <Table.Body>
                                {listaDeMatriculas.map(matricula => (
                                    <Fila key={matricula.id} {...matricula} />
                                ))}
                            </Table.Body>
                        </Table>
                    </div>
                );
            }}
        </Contexto.Consumer>
    );
};

const mapaDeNombresDeFiltros: Record<Filtro, string> = {
    'todas': 'Todos',
    'aprobadas': 'Solo aprobados',
    'rechazadas': 'Solo rechazados',
    'sin-supervision': 'Solo pendientes',
    'nulas': 'Solo nulos',
};

function itemsDesdeFiltros(alCambiarFiltro: (tipo: Filtro) => void) {
    return Object.entries(mapaDeNombresDeFiltros).map(([key, text]) => (
        <Dropdown.Item key={key} onClick={() => alCambiarFiltro(key as Filtro)}>
            {text}
        </Dropdown.Item>
    ));
}

export default TablaDeProcesos;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/ListaDeProcesos/TablaDeProcesos/index.tsx